import { _ } from "vue-underscore";
import api from "../utils/api.js";

import { SIZE_TOKENS, SIZE_TOKEN } from "../../config.js";

import { EventBus } from "../../utilities/eventBus.js";

export const account = {
    namespaced: true,
    state: {
        styleSettings: [
            {
                menuTitle: "Age",
                title: "How old are you?",
                subTitle: null,
                token: "age",
                type: "full-list",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: true,
            },
            {
                menuTitle: "Style",
                title: "How would you describe your style?",
                subTitle: "Choose all that apply",
                token: "style",
                type: "column-list",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: true,
            },
            {
                menuTitle: "Outfit Type",
                title: "What types of outfits are you looking for?",
                subTitle: "Choose all that apply",
                token: "occasion",
                type: "outfit-type",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: true,
            },
            {
                menuTitle: "Color Preference",
                title: "What colors do you NOT like to wear?",
                subTitle: "Choose all that apply",
                token: "color",
                type: "color",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: false,
            },
            {
                menuTitle: "Sizes",
                title: "What size do you typically wear? ",
                subTitle: null,
                token: "size",
                type: "size",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: false,
            },
            {
                menuTitle: "Body Type",
                title: "What is your body type?",
                subTitle: null,
                token: "body-type",
                type: "full-list",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: false,
            },
            {
                menuTitle: "Risk Tolerance",
                title: "How comfortable are you with taking risks?",
                subTitle: null,
                token: "risk",
                type: "risk",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: true,
            },
            {
                menuTitle: "Budget",
                title: "What are you willing to splurge on?",
                subTitle: "Choose all that apply",
                token: "budget-category",
                type: "column-list",
                loadOptions: true,
                options: [],
                optionsSelected: [],
                noSkip: false,
            },
        ],
    },
    getters: {
        styleSettings(state) {
            return state.styleSettings;
        },
        styleSetting: (state) => (token) => {
            let index = _.findIndex(state.styleSettings, {
                token: token,
            });
            return state.styleSettings[index];
        },
    },
    mutations: {
        setSettingOptions(state, payload) {
            state.styleSettings[payload.index].options = payload.options;
        },
        setSettingOptionsSelected(state, payload) {
            state.styleSettings[payload.index].optionsSelected =
                payload.options;
        },
        addSettingOptions(state, payload) {
            state.styleSettings[payload.index].options.push(payload.options);
        },
        setSettingOptionsSizeSelected(state, payload) {
            if (payload.options[0]) {
                state.styleSettings[payload.index].optionsSelected[
                    payload.sizeIndex
                ] = payload.options[0].product_option_value_id;
            }
        },
        setUserRiskPreference(state, value) {
            let index = _.findIndex(state.styleSettings, {
                token: "risk",
            });
            state.styleSettings[index].optionsSelected = value;
        },
    },
    actions: {
        async loadSetting(context, token) {
            await context.dispatch("loadSettingOption", token);
            await context.dispatch("loadSettingSelected", token);
        },
        loadSettingOption(context, token) {
            let uri = api.filtersUri() + token;
            let index = _.findIndex(context.state.styleSettings, {
                token: token,
            });
            return api
                .get(uri)
                .then((response) => {
                    context.commit("setSettingOptions", {
                        options: response.filter,
                        index,
                    });
                })
                .catch((response) => {
                    console.log("error loading setting");
                });
        },
        loadSettingSelected(context, token) {
            let uri = api.preferencesUri() + token;
            let index = _.findIndex(context.state.styleSettings, {
                token: token,
            });
            console.log(token);
            if (token == SIZE_TOKEN) {
                context.dispatch("loadSizeSettingsSelected", index);
            } else {
                return api
                    .get(uri)
                    .then((response) => {
                        context.commit("setSettingOptionsSelected", {
                            options: response.product_option_values.map(
                                (option) => {
                                    return option.product_option_value_id;
                                }
                            ),
                            index,
                        });
                    })
                    .catch((response) => {
                        console.log("error loading selected settings");
                    });
            }
        },
        loadSizeSettingSelected(context, payload) {
            let uri = api.preferencesUri() + payload.token;
            console.log(payload.token);
            return api
                .get(uri)
                .then((response) => {
                    context.commit("setSettingOptionsSizeSelected", {
                        options: response.product_option_values,
                        index: payload.index,
                        sizeIndex: payload.sizeIndex,
                    });
                })
                .catch((response) => {
                    console.log("error loading selected settings");
                });
        },
        async loadSizeSettingsSelected(context, index) {
            context.state.styleSettings[index].optionsSelected = [];
            for (let i = 0; i < SIZE_TOKENS.length; i++) {
                await context.dispatch("loadSizeSettingSelected", {
                    token: SIZE_TOKENS[i],
                    index,
                    sizeIndex: i,
                });
            }
        },
        loadSizeSetting(context, payload) {
            let uri = api.filtersUri();
            return api.get(uri + payload.token).then((response) => {
                context.commit("addSettingOptions", {
                    index: payload.index,
                    options: response.filter,
                });
            });
        },
        async loadSizeSettings(context, token) {
            let index = _.findIndex(context.state.styleSettings, {
                token: token,
            });

            context.commit("setSettingOptions", {
                index,
                options: [],
            });

            for (let i = 0; i < SIZE_TOKENS.length; i++) {
                await context.dispatch("loadSizeSetting", {
                    token: SIZE_TOKENS[i],
                    index,
                });
            }

            await context.dispatch("loadSizeSettingsSelected", index);
        },
        saveUserSetting(context, payload) {
            let uri = api.preferencesUri() + payload.token;

            return api
                .post(uri, {
                    product_option_value_ids: payload.optionValues,
                })
                .then((response) => {
                    EventBus.$emit("notification", "Preference Updated!");
                })
                .catch((response) => {
                    console.log("error loading selected settings");
                });
        },
        async saveUserSettingSize(context, optionValues) {
            for (let i = 0; i < SIZE_TOKENS.length; i++) {
                await context.dispatch("saveUserSetting", {
                    token: SIZE_TOKENS[i],
                    optionValues: [optionValues[i]],
                });
            }
            EventBus.$emit("notification", "Preference Updated!");
        },
        deleteAccount(context, payload) {
            let uri = api.accountUri() + "delete";

            return api.post(uri, { token: payload.token }).catch((error) => {
                this.$store.dispatch(
                    "errors/put",
                    error.message ||
                        "There has been an error deleting your account."
                );
            });
        },
    },
};
